const STANDARD_SERVICE_DESCRIPTIONS = {
    'Оплата посуточно': 'Daily payment',
    'Единоразовый платеж': 'One-time payment',
    'Стоимость рассчитывается индивидуально': 'Price is calculated individually',
    'Включение в договор аренды дополнительного водителя': 'Adding an additional driver to the rental agreement',
};

export const getServiceName = (service, lang = 'ru') => {
    if (!service) {
        return '';
    }

    if (lang === 'en') {
        return service.caraddonsitename_en
            || service.caraddontitle_en
            || service.caraddonsitename
            || service.caraddontitle
            || '';
    }

    return service.caraddonsitename || service.caraddontitle || '';
};

export const getServiceDescription = (service, lang = 'ru') => {
    if (!service) {
        return '';
    }

    const description = service.caraddonsitedescr || '';

    if (lang !== 'en') {
        return description;
    }

    if (service.caraddonsitedescr_en && service.caraddonsitedescr_en.length) {
        return service.caraddonsitedescr_en;
    }

    if (!description.length) {
        return '';
    }

    const trimmedDescription = description.trim();
    if (STANDARD_SERVICE_DESCRIPTIONS[trimmedDescription]) {
        return STANDARD_SERVICE_DESCRIPTIONS[trimmedDescription];
    }

    return description;
};

export const getInsuranceName = (insurance, lang = 'ru') => {
    if (!insurance) {
        return '';
    }

    if (lang === 'en') {
        return insurance.caraddontitle_en
            || insurance.caraddonsitename_en
            || insurance.caraddondocname
            || insurance.caraddontitle
            || insurance.caraddonname
            || '';
    }

    return insurance.caraddondocname
        || insurance.caraddontitle
        || insurance.caraddonsitename
        || insurance.caraddonname
        || '';
};

export const getInsuranceRule = (insurance, lang = 'ru') => {
    if (!insurance) {
        return '';
    }

    if (lang === 'en') {
        return insurance.caraddonrule_en || insurance.caraddonrule || '';
    }

    return insurance.caraddonrule || '';
};
